import { Injectable } from '@angular/core';
import { LocalizationService } from '../localization.service';
import { pharmaciesKeysForTitleAndDescription } from 'src/app/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class PharmaciesPageSeoHelperService {

  constructor(
    private readonly localizationService: LocalizationService
  ) { }

  /* TODO: We'll remove this part when BE will return title and description in needed response */
  buildTitleAndDescription(
    productName: string,
    productDescription: string,
    cityForH1: string
  ): { title: string, description: string } {
    const isMedicine: boolean = productDescription ? false : true;
    const keys = pharmaciesKeysForTitleAndDescription;

    let title: string = '';
    let description: string = '';

    if (this.localizationService.getLang() === 'ru') {
      title = `${productName} ${keys.buyRuSmall} ${keys.in} ${cityForH1}, ${keys.priceInPharmaciesRu} - ZDOROVI.UA`;
      if (isMedicine) {
        description = `${productName}: ${keys.priceInPharmaciesRu} ${keys.in} ${cityForH1}, ${keys.actualPricesRu} ${keys.in} ${cityForH1}`;
      } else {
        description = `${keys.buyRu} ${productName} ${keys.in} ${cityForH1} ${keys.affordablePriceRu} ᐉ ${keys.instructionsBookingRu}`;
      }
    } else {
      title = `${productName} ${keys.buyUaSmall} ${keys.in} ${cityForH1}, ${keys.priceInPharmaciesUa} - ZDOROVI.UA`;
      if (isMedicine) {
        description = `${productName}: ${keys.priceInPharmaciesUa} ${keys.in} ${cityForH1}, ${keys.actualPricesUa} ${keys.in} ${cityForH1}`;
      } else {
        description = `${keys.buyUa} ${productName} ${keys.in} ${cityForH1} ${keys.affordablePriceUa} ᐉ ${keys.instructionsBookingUa}`;
      }
    }

    return { title, description };
  }
}
